import React from 'react';
import clsx from 'clsx';

function LoadingSpinner({ size = 'md', text, className }) {
  const sizes = {
    sm: 'w-4 h-4',
    md: 'w-8 h-8', 
    lg: 'w-12 h-12',
    xl: 'w-16 h-16'
  };

  return (
    <div className={clsx('flex flex-col items-center justify-center', className)}>
      <div 
        className={clsx(
          'loading-spinner border-4 border-gray-200 border-t-primary-600 rounded-full animate-spin',
          sizes[size]
        )}
      />
      {text && (
        <p className="mt-2 text-sm text-gray-600">{text}</p>
      )}
    </div>
  );
}

export default LoadingSpinner;